import { BaseModel } from '@/app/modules/base/BaseModel';

/**
 * @deprecated legacy
 */
export class Bitrix extends BaseModel {
  static emailTriesUrl = '/api/user/{id}/emailConfirmation';
  static emailUpdateUrl = '/api/user/{id}/emailConfirmation';
  static codeConfirmUrl = '/api/user/{id}/emailConfirmation';
  static emailConfirmUrl = '/api/user/{id}/emailConfirmation/send';
  static replaceEmail = '/api/user/replace';
  static emailChangeClear = '/api/user/{id}/emailConfirmation/clean';
}
